function Contact(props)
{
    return(
        <div id="contact">
          <div id="body-title" className="contact">
              {"Contact"}
          </div>
          <div id="body-text">
            <dl>
                <dt> Mi Young Kim </dt>
                <dt> lives in Fremont, California </dt>
                <dt> <a href="mailto:miyoungid1@gmail.com"> miyoungid1@gmail.com </a> </dt>
            </dl>
          </div>
        </div>
    )
}
export default Contact;
